<template>
<div style="height: 100%; margin: 0 calc(100vw/10) calc(100vw/20) calc(100vw/10);">
  <div class="glitch" data-text="MY PROJECTS">MY PROJECTS</div>
  <div class="parent">
    <div class="mid-parent-2">
      <div class="child">
        <Project
        link="https://github.com/alemastro97/my_air"
        title="My Air" img="my_air" desc="A mobile application developed entirely in Flutter that collects data on air quality"/>
      </div>
      <div class="child">
        <Project 
        title="InsightUp" img="insightUp" desc="(@Digitiamo) Tourist center data aggregator for trend analysis of the various accommodation facilities"/>
        
      </div>
    </div>
    <div class="mid-parent-1">
      <div class="child">
        <Project
        link="https://github.com/alemastro97/Rubiks-Cube-WebGL/tree/main/RubiksCube"
        title="WebGL Rubiks-Cube" img="img_pg1" desc="A web app fully made in WebGL"/>
      </div>
      <div class="child">
        <Project link="https://github.com/alemastro97/my_air"
        title="ODIN Web" img="odin" desc="ODIN Web is an interactive Dashboard for black-box deep Learning error diagnosis with an integrated tool to annotate datasets easly"
        />
      </div>
      <div class="child">
        <Project
        title="Carrefour Order Trend" img="cr" desc="Order analysis platform developed in Digitiamo and future trends"
        />
      </div>
    </div>
</div>
</div>
</template>

<script>
import Project from "@/components/Project.vue";

export default {
  name: "ProjectsView",
  data() {
    return {
    };
  },
  components: {
    Project
  }
};
</script>

<style lang="scss" scoped>
.parent {
  padding: 30px;
  margin: 0 calc(-100vw/15) 0 calc(-100vw/15);
  height: calc(100% - (100vw/20));
display: flex;
flex-direction: row;
gap:calc(100vw/50);

}
.mid-parent-1,.mid-parent-2 {
  width: 50%;
  height: 100%;
  display: flex;
  gap:calc(100vw/50);
  flex-wrap: wrap 1;
  flex-direction: column;
}
.mid-parent-1>.child {
  max-height: 33%;
}
.mid-parent-2>.child {
  max-height: 49.5%;
}
.glitch {
  color: white;
  font-size: clamp(30px, 3vw, 70px);
  position: relative;
  width: 100%;
  margin: 0 0 !important;
  &.list {
    font-size: 35px;
    font-family: "Courier New", Courier, monospace;
  }
}
@keyframes noise-anim {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}
.glitch:after {
  content: attr(data-text);
  position: absolute;
  left: 2px;
  text-shadow: -1px 0 red;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim 2s infinite linear alternate-reverse;
}

@keyframes noise-anim-2 {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}
.glitch:before {
  content: attr(data-text);
  position: absolute;
  left: -2px;
  text-shadow: 1px 0 blue;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim-2 3s infinite linear alternate-reverse;
}
@media only screen and (max-width: 768px) {
  .parent {
    padding: 0;
    margin: 0 calc(-100vw/15) 0 calc(-100vw/15);
    height: auto;
    display: flex;
    flex-direction: column;
    gap: calc(100vw/50);

  }

  .mid-parent-1,
  .mid-parent-2 {
    width: 90vw;
    height: auto;
    display: flex;
    gap: calc(100vw/50);
    flex-wrap: wrap 1;
    flex-direction: column;
  }


}
</style>
